import { Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import Loader from '../../../common/loader/Loader'
import { MarketWastagesAmountAndVolumes } from '../../../common/marketSales/types'
import MarketWastageTable from '../../../common/monthlyWeeklyInfo/MarketWastageTable'
import { Query } from '../../../react-apollo/Components'
import { i18n } from '../../index'
import css from '../weeklyInfoPage.css'
import { fetchWeeklyInfoMarketWastages } from '../weeklyInfoQueries'

interface Props {
  stationId: string
  date: string
}

interface QueryResponse {
  weeklyInfoMarketWastages?: MarketWastagesAmountAndVolumes[]
}

interface QueryVariables {
  date: string
  stationId: string
}

export default function MarketWastages({ stationId, date }: Props) {
  return (
    <Query<QueryResponse, QueryVariables> query={fetchWeeklyInfoMarketWastages} variables={{ date, stationId }}>
      {({ data, loading, error }) => (
        <Loader
          {...{
            loading,
            error,
          }}
        >
          <div className={css.salesAndHours}>
            <Typography variant='h6' gutterBottom>
              {i18n.t('weeklyInfo.title.marketWastage', {
                week: `vko. ${moment(date).isoWeek()} ${moment(date).startOf('week').format('D.M.')}-${moment(date)
                  .endOf('week')
                  .format('D.M.')}`,
              })}
            </Typography>
            <MarketWastageTable marketWastages={data.weeklyInfoMarketWastages} date={date} stationId={stationId} />
          </div>
        </Loader>
      )}
    </Query>
  )
}
